module.exports = __webpack_public_path__ + "catalog/items/simple-stair/textures/white-paint.jpg";